function main() {
  const needResourceList = [window.$, window.jQuery, window.Swiper];

  if (needResourceList.filter(Boolean).length !== needResourceList.length) {
    return setTimeout(main, 240);
  }

  const product = window.product;
  console.log("product", product);

  $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
    $(".sp_h_cart_view").html(result.item_count);
  });

  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );

    $(document).on("click", ".btn-quantity", function () {
      var inputDom = $(this).siblings('input[type="number"]');
      var inputVal = inputDom.val();
      if ($(this).hasClass("btn-quantity-plus")) {
        inputVal = parseInt(inputVal) + 1;
      } else {
        inputVal = parseInt(inputVal) - 1;
      }
      if (inputVal < 1) {
        inputVal = 1;
      }
      inputDom.val(inputVal).change();
    });
  });

  let b1 = new Swiper("#b1", {
    // loop: true,
    // autoplay: true,
    slidesPerView: 3,
    centeredSlides: true,
    centeredSlidesBounds: true,
    navigation: {
      prevEl: ".button-prev",
      nextEl: ".button-next",
    },
  });
  let b2 = new Swiper("#b2", {
    navigation: {
      prevEl: ".button-prev",
      nextEl: ".button-next",
    },
  });

  $(".circles div").click(function (event) {
    let index = $(this).index();
    b1.slideTo(index, 1000, false);
  });
  $(".colorList .color").click(function (event) {
    let index = $(this).index();
    b2.slideTo(index, 1000, false);
  });
  $(".choose-btn").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    if ($(".choose-btn.active").index() == 0) {
      $(".box1").css("display", "block");
      $(".box2").css("display", "none");
    } else {
      $(".box2").css("display", "block");
      $(".box1").css("display", "none");
    }
  });

  $(".select").click(function () {
    $(".optList").not($(this).siblings(".optList")).hide();
    $(this).siblings(".optList").toggle();
  });

  var imgList = {
    Negro:
      "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/black2_6326253d-ccc7-433a-8347-dc3373f7c79b.png?v=1715248764",
    "Gris oscuro":
      "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/Dark_grey2.png?v=1687255985",
    Weiss:
      "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/white2.png?v=1687255986",
    Verde:
      "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/green2.png?v=1687255985",
    Caqui:
      "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/khaki2.png?v=1687255985",
    Café: "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/coffer2.png?v=1687255984",
    Azul: "https://cdn.shopify.com/s/files/1/0604/6315/3308/files/blue2.png?v=1687255984",
  };

  $(".opt").click(function () {
    let text = $(this).children().html();
    $(this).parent(".optList").hide();
    $(this).parent().siblings(".select").children(".font2").html(text);
    $(this).addClass("picked").siblings().removeClass("picked");
    if ($(this).parent().hasClass("color1")) {
      $("#p1 img").attr("src", imgList[text]);
    }
    if ($(this).parent().hasClass("color2")) {
      $("#p2 img").attr("src", imgList[text]);
    }
    $(".optList").not($(this).siblings(".optList")).hide();
    $(this).siblings(".optList").toggle();
  });

  var skuList = [
    [
      product.variants[0].id,
      product.variants[1].id,
      product.variants[2].id,
      product.variants[3].id,
      product.variants[4].id,
      product.variants[5].id,
      product.variants[6].id,
      product.variants[7].id,
      product.variants[8].id,
    ],
    [
      product.variants[9].id,
      product.variants[10].id,
      product.variants[11].id,
      product.variants[12].id,
      product.variants[13].id,
      product.variants[14].id,
      product.variants[15].id,
      product.variants[16].id,
      product.variants[17].id,
    ],
    [
      product.variants[18].id,
      product.variants[19].id,
      product.variants[20].id,
      product.variants[21].id,
      product.variants[22].id,
      product.variants[23].id,
      product.variants[24].id,
      product.variants[25].id,
      product.variants[26].id,
    ],
    [
      product.variants[27].id,
      product.variants[28].id,
      product.variants[29].id,
      product.variants[30].id,
      product.variants[31].id,
      product.variants[32].id,
      product.variants[33].id,
      product.variants[34].id,
      product.variants[35].id,
    ],
    [
      product.variants[36].id,
      product.variants[37].id,
      product.variants[38].id,
      product.variants[39].id,
      product.variants[40].id,
      product.variants[41].id,
      product.variants[42].id,
      product.variants[43].id,
      product.variants[44].id,
    ],
    [
      product.variants[45].id,
      product.variants[46].id,
      product.variants[47].id,
      product.variants[48].id,
      product.variants[49].id,
      product.variants[50].id,
      product.variants[51].id,
      product.variants[52].id,
      product.variants[53].id,
    ],
    [
      product.variants[54].id,
      product.variants[55].id,
      product.variants[56].id,
      product.variants[57].id,
      product.variants[58].id,
      product.variants[59].id,
      product.variants[60].id,
      product.variants[61].id,
      product.variants[62].id,
    ],
  ];

  function atc(val) {
    if (val == 1) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: skuList[$("div#b2 .swiper-slide.swiper-slide-active").index()][
            $(".optList.opi1 .picked").index()
          ],
          quantity: $("input#qty1").val(),
        },
        success: function () {
          $(".sp_pop_text").toggle();
          setTimeout(function () {
            $(".sp_pop_text").toggle();
          }, 1200);
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".sp_h_cart_view").html(result.item_count);
          });
        },
        dataType: "json",
      });
    } else {
      let formData = {
        items: [
          {
            id: skuList[$(".optList.opi2 .picked").index()][
              $(".optList.opi3 .picked").index()
            ],
            quantity: $("input#qty2").val(),
          },
          {
            id: skuList[$(".optList.opi4 .picked").index()][
              $(".optList.opi5 .picked").index()
            ],
            quantity: $("input#qty2").val(),
          },
        ],
      };
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          $(".sp_pop_text").toggle();
          setTimeout(function () {
            $(".sp_pop_text").toggle();
          }, 1200);
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".sp_h_cart_view").html(result.item_count);
          });
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }
  $(".add-cart-btn").click(atc);

  function emitCheckout() {
    const val = $(".choose-btn.active").attr("data-mode");
    if (val == 1) {
      window.location.href =
        "/cart/" +
        skuList[$("div#b2 .swiper-slide.swiper-slide-active").index()][
          $(".optList.opi1 .picked").index()
        ] +
        ":" +
        $("input#qty1").val();
    } else {
      window.location.href =
        "/cart/" +
        skuList[$(".optList.opi2 .picked").index()][
          $(".optList.opi3 .picked").index()
        ] +
        ":" +
        $("input#qty2").val() +
        "," +
        skuList[$(".optList.opi4 .picked").index()][
          $(".optList.opi5 .picked").index()
        ] +
        ":" +
        $("input#qty2").val();
    }
  }

  $(".pay-checkout-btn").click(emitCheckout);
}

main();
